module.exports = __webpack_public_path__ + "static/media/letter.ca4fd714.svg";